import { useEffect } from 'react';
import { useUIStore } from '@/lib/store/uiStore';
import { useSessionStore } from '@/lib/store/sessionStore';

const MODE_MAP: Record<string, 'preview' | 'diff' | 'terminal' | 'files' | 'tasks' | 'plan'> = {
  '1': 'preview',
  '2': 'diff',
  '3': 'terminal',
  '4': 'files',
  '5': 'tasks',
  '6': 'plan',
};

export function useModeShortcuts() {
  const setMode = useUIStore((s) => s.setMode);
  const toggleInspector = useUIStore((s) => s.toggleInspector);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (!(e.metaKey || e.ctrlKey)) return;
      const t = e.target as HTMLElement | null;
      const inField = t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA');

      // ⌘\ — toggle inspector (works even from textarea)
      if (e.key === '\\') {
        e.preventDefault();
        toggleInspector();
        return;
      }

      // ⌘B — toggle session rail (VS Code convention)
      if (e.key.toLowerCase() === 'b') {
        e.preventDefault();
        useUIStore.getState().toggleRail();
        return;
      }

      // ⌘, — open settings
      if (e.key === ',') {
        e.preventDefault();
        useUIStore.getState().setSettingsOpen(true);
        return;
      }

      // ⌘⇧N / ⌘⇧L — browser-safe (⌘N/⌘L are reserved by the browser).
      if (e.shiftKey && e.key.toLowerCase() === 'n') {
        e.preventDefault();
        useSessionStore.getState().newSession('claude_cli');
        return;
      }
      if (e.shiftKey && e.key.toLowerCase() === 'l') {
        e.preventDefault();
        const { activeId, clearMessages } = useSessionStore.getState();
        if (activeId) clearMessages(activeId);
        return;
      }

      if (inField) return;
      const target = MODE_MAP[e.key];
      if (!target) return;
      e.preventDefault();
      setMode(target);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [setMode, toggleInspector]);
}
